import React, { useState, useEffect } from "react";
import apiService from "../../services/apiService";

const ScheduleFollowUp = ({ sfContext, sfAuthError, sfSession, refreshSfToken }) => {
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState({ type: "", text: "" });
    const FOLLOW_UP_TYPES = [
        { value: "Call Client", label: "Call Client" },
        { value: "Follow up on email", label: "Follow up on email" },
        { value: "Check claim status", label: "Check claim status" },
    ];
    const [followUpType, setFollowUpType] = useState("Call Client");
    // State for the fields requested by the user

    const [followUpDate, setFollowUpDate] = useState("");
    const [followUpTime, setFollowUpTime] = useState("14:00");

    useEffect(() => {
        // Set default date to 1 week from now
        const nextWeek = new Date();
        nextWeek.setDate(nextWeek.getDate() + 7);
        setFollowUpDate(nextWeek.toISOString().split("T")[0]);
    }, [sfContext]);

    const handleCreateFollowUp = async () => {
        setLoading(true);
        setMessage({ type: "", text: "" });

        if (sfAuthError) {
            setMessage({ type: "error", text: "Salesforce access restricted. Follow-up scheduling disabled." });
            setLoading(false);
            setTimeout(() => setMessage({ type: "", text: "" }), 5000);
            return;
        }

        if (!sfContext || Object.keys(sfContext).length === 0 || sfContext.matchFound === false) {
            setMessage({ type: "error", text: "Salesforce account not selected." });
            setLoading(false);
            setTimeout(() => setMessage({ type: "", text: "" }), 5000);
            return;
        }

        try {
            /*
            let token = sfSession?.accessToken;
            let instanceUrl = sfSession?.instanceUrl;

            if (!token || !instanceUrl) {
                const refreshed = await refreshSfToken?.();
                if (refreshed) {
                    token = refreshed.accessToken;
                    instanceUrl = refreshed.instanceUrl;
                } else {
                    setMessage({ type: "error", text: "Salesforce session expired. Please retry." });
                    setLoading(false);
                    return;
                }
            }

            // Determine recordId, recordType, and senderName for dynamic subject
            let recordId = "";
            let recordType = "Account";
            let senderName = "";
            if (sfContext && sfContext.accountId) {
                recordId = sfContext.accountId;
                recordType = "Account";
                senderName = sfContext.accountName;
            } else if (sfContext && sfContext.contacts && sfContext.contacts.length > 0) {
                recordId = sfContext.contacts[0].contactId;
                recordType = "Contact";
                senderName = sfContext.contacts[0].name;
            }

            if (!recordId) {
                setMessage({ type: "error", text: "Salesforce account not selected." });
                setLoading(false);
                setTimeout(() => setMessage({ type: "", text: "" }), 5000);
                return;
            }

            const dynamicSubject = senderName ? `${followUpType} - ${senderName}` : followUpType;

            const payload = {
                instance_url: instanceUrl,
                access_token: token,
                subject: dynamicSubject,
                followUpType,
                description: "",
                followUpDate,
                followUpTime,
                durationMinutes: 30, // Default duration 30 mins
                recordId,
                recordType,
                reminderMinutesBefore: 15, // Default reminder 15 mins
                createAsEvent: true
            };
            const result = await apiService.scheduleFollowUpCall(payload);

            if (result.error) {
                setMessage({ type: "error", text: result.details || result.error });
            } else {
                setMessage({ type: "success", text: "Follow-up scheduled successfully!" });
            }
            */

            // Simulation of MOCK follow-up scheduling in Salesforce
            await new Promise(resolve => setTimeout(resolve, 1500));
            setMessage({ type: "success", text: "Follow-up scheduled successfully in Salesforce!" });

            setTimeout(() => setMessage({ type: "", text: "" }), 5000);
        } catch (err) {
            console.error("Schedule follow-up failed:", err);
            setMessage({ type: "error", text: "Failed to schedule follow-up." });
            setTimeout(() => setMessage({ type: "", text: "" }), 5000);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="action-card">
            <div className="action-card-header">
                <span className="action-icon calendar-icon">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#1a56db" strokeWidth="2.5">
                        <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                        <line x1="16" y1="2" x2="16" y2="6"></line>
                        <line x1="8" y1="2" x2="8" y2="6"></line>
                        <line x1="3" y1="10" x2="21" y2="10"></line>
                    </svg>
                </span>
                <span className="action-title">Schedule Follow-up</span>
            </div>

            <div className="action-card-body">
                {message.text && (
                    <div className={`action-message ${message.type}`}>
                        {message.text}
                    </div>
                )}


                <div className="action-form-group">
                    <label className="action-label">Follow-up Type</label>
                    <select
                        className="action-input"
                        value={followUpType}
                        onChange={(e) => setFollowUpType(e.target.value)}
                    >
                        {FOLLOW_UP_TYPES.map((opt) => (
                            <option key={opt.value} value={opt.value}>
                                {opt.label}
                            </option>
                        ))}
                    </select>
                </div>
                <div className="action-form-group">
                    <label className="action-label">Date & Time</label>
                    <div className="side-by-side">
                        <input
                            type="date"
                            className="action-input"
                            value={followUpDate}
                            onChange={(e) => setFollowUpDate(e.target.value)}
                            min={new Date().toISOString().split("T")[0]}
                        />

                        <input
                            type="time"
                            className="action-input"
                            value={followUpTime}
                            onChange={(e) => setFollowUpTime(e.target.value)}
                        />
                    </div>
                </div>





                <button
                    className="action-btn-primary full-width"
                    onClick={handleCreateFollowUp}
                    disabled={loading}
                >
                    {loading ? "Scheduling..." : "Create Follow-up"}
                </button>
            </div>
        </div>
    );
};

export default ScheduleFollowUp;
